// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionsOutline_wrapper__3EhW2"};